import React from 'react';

import { Box } from '@betterment/samba-react';

export const AccountIcon: React.FC<{ accountIconUrl: string; envelopeIconUrl?: string }> = ({
  accountIconUrl,
  envelopeIconUrl,
}) => (
  <Box css={{ position: 'relative', width: 'size.450', height: 'size.450' }}>
    {envelopeIconUrl && (
      <Box
        css={{
          width: 'size.250',
          height: 'size.250',
          padding: '0',
          borderRadius: 'medium',
          borderColor: 'border.onPrimary',
          border: '2px solid',
          position: 'absolute',
          top: '-12px',
          left: '-2px',
          overflow: 'hidden',
        }}
      >
        <img src={envelopeIconUrl} alt="EnvelopeIcon" style={{ position: 'absolute' }} />
      </Box>
    )}
    <img src={accountIconUrl} alt="Icon" />
  </Box>
);
